import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeOff = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 5C7 5 2.73 8.11 1 12C1.73 13.64 2.96 15.09 4.5 16.18L2.71 17.97L4.12 19.38L19.38 4.12L17.97 2.71L15.54 5.14C14.43 5.05 13.24 5 12 5ZM12 7C12.72 7 13.41 7.08 14.07 7.21L12.41 8.87C12.28 8.85 12.14 8.84 12 8.84C10.26 8.84 8.84 10.26 8.84 12C8.84 12.14 8.85 12.28 8.87 12.41L7.21 14.07C7.08 13.41 7 12.72 7 12C7 9.24 9.24 7 12 7ZM19.5 7.82L17.82 9.5C18.47 10.2 18.97 11.05 19.26 12C18.22 14.32 15.35 17 12 17C11.28 17 10.59 16.92 9.93 16.79L8.26 18.46C9.41 18.81 10.67 19 12 19C17 19 21.27 15.89 23 12C22.27 10.36 21.04 8.91 19.5 7.82ZM14.12 11.42L11.42 14.12C12.54 14.38 13.62 13.54 14.12 12.42V11.42Z",
		fill: "currentColor"
	})
});
export default SvgEyeOff;
